'use client'
import { FC, PropsWithChildren, useEffect, useState } from 'react'
import { getAuthSession } from '@/root/shared-api/auth/authService'
import { AuthContext, AuthContextStateSetter, INITIAL_AUTH_CONTEXT } from './AuthContext'

interface AuthContextProviderProps extends PropsWithChildren {
  initialIsAuth?: boolean
}

const AuthContextProvider: FC<AuthContextProviderProps> = ({ children, initialIsAuth = false }) => {
  const [authState, setAuthState] = useState(() => ({
    ...INITIAL_AUTH_CONTEXT,
    isAuth: initialIsAuth,
  }))

  useEffect(() => {
    let isMounted = true

    getAuthSession()
      .then(({ data }) => {
        if (!isMounted) {
          return
        }

        setAuthState({
          token: null,
          isAuth: data.isAuthenticated,
        })
      })
      .catch(() => {
        if (!isMounted) {
          return
        }

        setAuthState(INITIAL_AUTH_CONTEXT)
      })

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <AuthContextStateSetter.Provider value={setAuthState}>
      <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
    </AuthContextStateSetter.Provider>
  )
}

export default AuthContextProvider
